import React, { Component } from 'react';
import { withRouter } from 'react-router'
// import Constants from './Constants.js';

class Base extends Component {

  render() {
    return (
      <div>
        <div className="base-component">
          {this.props.children}
        </div>     
      </div>
    );
  }
}

export default withRouter(Base);


// WEBPACK FOOTER //
// ./src/components/Base.js